import React, { useState, useEffect } from "react";
import { fetchAllAdminFundTxns } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const FormHistory = () => {
  const token = useSelector((store) => store.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);

  const getWalletData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchAllAdminFundTxns(token);
      setTableData(response.data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getWalletData();
  }, [token]);

  return (
   <div className="pendding-report-table-container">
       <h2 className="pendding-report-table-title">Wallet Transactions</h2>
       <table className="pendding-table">
        <thead>
          <tr>
            <th>Deposit Amount</th>
            <th>Previous Balance</th>
            <th>Available Balance</th>
            <th>UTR</th>
            <th>Payment Mode</th>
            <th>Remarks</th>
            <th>Status</th>
          </tr>
        </thead>
           <tbody>
             {isLoading ? (
               <tr><td colSpan="6">Loading...</td></tr>
             ) : tableData?.length > 0 ? (
               tableData.map((transaction, index) => (
                 <tr key={index}>
                   <td>₹ {transaction.depositAmount}</td>
                   <td>₹ {transaction.previousBalance}</td>
                   <td>₹ {transaction.availableBalance}</td>
                   <td>{transaction.utr || "-"}</td>
                   <td>{transaction.paymentMode || "-"}</td>
                   <td>{transaction.remark || "-"}</td>
                   <td>{transaction.status || "-"}</td>
                 </tr>
               ))
             ) : (
               <tr><td colSpan="9">No Request Fund Load found.</td></tr>
             )}
           </tbody>
      </table>
    </div>
  );
};

export default FormHistory;
